import { IS_LOBBIE_PROD } from ".";

export const MXMERCHANT_BASE_URL_CHECKOUT = IS_LOBBIE_PROD
    ? "https://api.mxmerchant.com/checkout/v3"
    : "https://sandbox.api.mxmerchant.com/checkout/v3";

// TODO: PAYMENTS_1 is the prod endpoint right?
export const MXMERCHANT_PORTAL_API_KEYS_URL = IS_LOBBIE_PROD
    ? "https://app.mxmerchant.com/mx6/settings/apiKeys"
    : "https://sandbox-app.mxmerchant.com/mx6/settings/apiKeys";
